// extracted by mini-css-extract-plugin
export var wide = "articleImages-module--wide--p6dph";